export default "__VITE_ASSET__DUl_g44f__"